import { createSvgEl } from '@learnforge/demo-render';

export interface GridOptions {
  cols: number;
  rows: number;
  shaded: ReadonlySet<number>;
  partialShaded?: ReadonlyMap<number, number>;
  rowEmphasis?: ReadonlySet<number>;
  colEmphasis?: ReadonlySet<number>;
  width: number;
  height: number;
  onCellClick?(index: number): void;
  onDragShade?(indices: number[]): void;
}

export interface GridHandle {
  group: SVGGElement;
  update(opts: Partial<GridOptions>): void;
  destroy(): void;
}

export function createGrid(parent: SVGGElement, initial: GridOptions): GridHandle {
  const group = createSvgEl('g', { class: 'arith-grid' });
  parent.appendChild(group);
  let opts = { ...initial };

  function render(): void {
    while (group.firstChild) group.removeChild(group.firstChild);
    const { cols, rows, shaded, partialShaded, width, height } = opts;
    const cellW = width / cols;
    const cellH = height / rows;
    for (let r = 0; r < rows; r += 1) {
      for (let c = 0; c < cols; c += 1) {
        const idx = r * cols + c;
        const partial = partialShaded?.get(idx);
        const cls = ['arith-grid-cell'];
        if (shaded.has(idx)) cls.push('shaded');
        if (partial !== undefined) cls.push('partial');
        const cell = createSvgEl('rect', {
          class: cls.join(' '),
          x: c * cellW,
          y: r * cellH,
          width: cellW,
          height: cellH,
          'data-index': idx,
        });
        group.appendChild(cell);
        if (partial !== undefined) {
          const overlay = createSvgEl('rect', {
            class: 'arith-grid-cell-partial-overlay',
            x: c * cellW,
            y: r * cellH,
            width: cellW * partial,
            height: cellH,
          });
          group.appendChild(overlay);
        }
        cell.addEventListener('click', () => opts.onCellClick?.(idx));
      }
    }
  }

  render();

  return {
    group,
    update(next: Partial<GridOptions>) {
      opts = { ...opts, ...next };
      render();
    },
    destroy() {
      if (group.parentNode) group.parentNode.removeChild(group);
    },
  };
}
